var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("KZI2")]),_c('div',{staticClass:"value"},[_vm._v("81.7")])])}]

export { render, staticRenderFns }